import React, { useState } from "react";
import ReactDOM from "react-dom";

const ZoomImage = ({ src, alt, style }) => {
  const [zoomStyle, setZoomStyle] = useState({
    backgroundImage: `url(${src})`,
    backgroundPosition: "0% 0%",
    display: "none",
    top: 0,
    left: 0,
  });

  const handleMouseMove = (e) => {
    const { currentTarget: target } = e;
    const { left, top, width, height } = target.getBoundingClientRect();
    
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomStyle({
      backgroundImage: `url(${src})`,
      backgroundPosition: `${x}% ${y}%`,
      display: "block",
      top: e.clientY - 200,
      left: e.clientX + 20,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle((prev) => ({ ...prev, display: "none" }));
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        cursor: "zoom-in",
        ...style,
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          display: "block",
          maxWidth: "100%",
          maxHeight: "100%",
        }}
      />
      {ReactDOM.createPortal(
        <div
          style={{
            position: "fixed",
            width: "400px",
            height: "400px",
            pointerEvents: "none",
            border: "3px solid #fff",
            boxShadow: "0 4px 15px rgba(0,0,0,0.4)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "1000px",
            zIndex: 10000,
            borderRadius: "12px",
            ...zoomStyle,
          }}
        />,
        document.body
      )}
    </div>
  );
};

export default ZoomImage;

